<template>
    <div class="category-item-section">
        
        <!-- 节 -->
        <div class="section-title"> {{ info.name }} </div>
        <div class="section-content">

            <template v-for="item in info.childrenList">
                <course-item :key="item.id" v-if="item.type !== 0" :info="item"
                                :dateExpireStatus="dateExpireStatus"
                                :currentlyPlay="currentlyPlay"/>

                <div class="section-item" :key="item.id" v-else>
                
                    <!-- 小节 -->
                    <div class="chapter-title"> 
                        <div class="radio"></div> 
                        <p> {{ item.name }}</p>
                    </div>
                    <div class="chapter-body">

                        <template v-for="el in item.childrenList">
                            <course-item :key="el.id"
                                v-if="el.type !== 0"
                                :info="el"
                                :dateExpireStatus="dateExpireStatus"
                                :currentlyPlay="currentlyPlay"></course-item>
                            
                            <small-section :key="el.id" v-else
                                :info="el"
                                :dateExpireStatus="dateExpireStatus"
                                :currentlyPlay="currentlyPlay"></small-section>                    

                        </template>
                    </div>
                </div>
            </template>
        </div>  
    </div> 
</template>

<script>
import CourseItem from './course.vue';
import SmallSection from './small-section.vue';

export default {
    name: 'CourseSection',

    props: {
        currentlyPlay: {
            type: Object,
            default: () => ({
                id: null
            })
        },
        dateExpireStatus:{
            type:Number,
            default:null
        },
        info: {
            type: Object,
            default: () => {}
        },
        isb: {
            type: Boolean,
            default: false
        }
    },

    components: {
        CourseItem,
        SmallSection
    },
}
</script>